import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  registerModelState: false,
  inquiryModelState: false,
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    openRegisterModel: (state, action) => {
      state.registerModelState = action.payload;
    },
    openInquiryModel: (state, action) => {
      state.inquiryModelState = action.payload;
    },
  },
});

export const { openInquiryModel, openRegisterModel } = commonSlice.actions;
export default commonSlice.reducer;
